import { E32 } from "./endesga32";

export interface Rarity {
  key: string;
  name: string;
  color: string;
  label: string;
  borderWidth: number;
}

// Rarity colors are picked for identity, not nearest-neighbor: the
// legendary border has to read as gold, the rare border as blue, etc.
// Mist (the off-white) keeps common visually quiet against the panel.
export const RARITIES: Record<string, Rarity> = {
  common: { key: "common", name: "Common", color: E32.mist, label: "C", borderWidth: 2 },
  uncommon: { key: "uncommon", name: "Uncommon", color: E32.forest, label: "U", borderWidth: 2 },
  rare: { key: "rare", name: "Rare", color: E32.cobalt, label: "R", borderWidth: 3 },
  legendary: { key: "legendary", name: "Legendary", color: E32.amber, label: "L", borderWidth: 3 },
};

export function rarityFor(key: string | null | undefined): Rarity {
  if (key && RARITIES[key]) return RARITIES[key];
  return RARITIES.common;
}
